import React from "react";
import { Box, Typography } from "@mui/material";

const OrderHeader = ({ order }) => {
  if (!order) return null;

  return (
    <Box mb={4} textAlign="center" className="thank-you-header">
      <Typography variant="h4" fontWeight="bold">
        🎉 Thank You for Your Order!
      </Typography>
      <Typography variant="subtitle1">
        Order ID: <strong>{order.meta?.orderId}</strong>
      </Typography>
    </Box>
  );
};

export default OrderHeader;
